import { Input, Select } from 'antd';
import { ChangeEvent, useState } from 'react';
import { useAppDispatch } from 'app/store';
import { uiModel } from 'entities/ui';
import { SearchParams, options } from '../config';
import style from './index.module.scss';

export const Search = () => {
  const dispatch = useAppDispatch();
  const { Search } = Input;

  const [searchParam, setSearchParam] = useState<SearchParams>();
  const [searchValue, setSearchValue] = useState<string>('');

  const onChangeSelect = (value: SearchParams) => {
    setSearchValue('');
    setSearchParam(value);
  };

  const onChangeSearch = (event: ChangeEvent<HTMLInputElement>) => {
    const value =
      searchParam === SearchParams.personnelNumber ? event.target.value.replace(/[^0-9]/g, '') : event.target.value;

    if (event.type == 'change') {
      setSearchValue(value);
    }
    if (event.type === 'click') {
      setSearchValue('');
      dispatch(uiModel.Substitutions.actions.resetSearch());
    }
  };

  const onSearch = () => {
    if (searchParam) {
      dispatch(uiModel.Substitutions.actions.setSearch({ [searchParam]: searchValue }));
    }
  };

  const onClearSelect = () => {
    setSearchValue('');
    dispatch(uiModel.Substitutions.actions.resetSearch());
  };

  return (
    <div className={style.wrap}>
      <Select
        placeholder="Параметр поиска"
        options={options}
        onChange={onChangeSelect}
        onClear={onClearSelect}
        allowClear
        className={style.paramSelect}
      />
      <Search
        placeholder="Поиск"
        value={searchValue}
        onChange={onChangeSearch}
        onSearch={onSearch}
        disabled={!searchParam}
        maxLength={searchParam === SearchParams.personnelNumber ? 8 : undefined}
        allowClear
        className={style.searchInput}
      />
    </div>
  );
};
